import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Table from "../../../components/table";
// import { FaEdit, FaTrash } from "react-icons/fa";
import UpdateModal from "./updateModal";
import RemoveModal from "./removeModal";
import { getPlans } from "../../../api/endpoint";
import toast from "react-hot-toast";
import axios from "axios";
import AddModal from "./addModal";
import Loader from "../../../components/loader";
import UpdateAllModal from "./updateAllModal";
import { togglePlanStatus } from "../../../api/endpoint";

const PaymentConfig = () => {
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [isUpdateAllOpen, setIsUpdateAllOpen] = useState(false);
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const response = await axios.get(getPlans, {
        headers: {
          Authorization: `Bearer ${auth}`,
        },
      });
      setPlans(response?.data);
    } catch (error) {
      console.error("Error fetching subscription plans:", error);
      toast.error("Failed to load Subscription Plans.");
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (e, plan) => {
    try {
      setLoading(true)
      await axios.post(
        togglePlanStatus,
        {},
        {
          params: { id: plan?.id, status: e.target.checked },
          headers: { Authorization: `Bearer ${auth}` },
        }
      );
      toast.success("Plan status changed successfully");
      fetchPlans();
    } catch (error) {
      console.error(error);
      toast.error(`${error?.response?.data?.error_description} - ${error?.response?.data?.user_description}` || "Error updating plan status");
    } finally {
      setLoading(false)
    }
  };

  // const getActionButtons = (plan) => {
  //   return (
  //     <div className="d-flex justify-content-center gap-3">
  //       <button
  //         className="btn p-0"
  //         onClick={() => {
  //           setSelectedPlan(plan);
  //           if (plan) setIsUpdateOpen(true);
  //         }}
  //       >
  //         <FaEdit size={26} />
  //       </button>
  //       <button
  //         className="btn p-0"
  //         onClick={() => {
  //           setSelectedPlan(plan);
  //           setIsRemoveOpen(true);
  //         }}
  //       >
  //         <FaTrash size={26} />
  //       </button>
  //     </div>
  //   );
  // };

  const headings = [
    // {
    //   name: "ID",
    //   fieldName: "id",
    //   isSortable: true,
    //   sortKey: "none",
    // },
    {
      name: "Package",
      fieldName: "package",
      isSortable: true,
      sortKey: "none",
    },
    {
      name: "Price",
      fieldName: "price",
      isSortable: true,
      sortKey: "none",
    },
    {
      name: "Details",
      fieldName: "details",
      isSortable: false,
      sortKey: "none",
    },
    // {
    //   name: "Actions",
    //   fieldName: "actions",
    //   isSortable: false,
    //   sortKey: "none",
    // },
  ];

  const tableRows = plans?.map((plan) => ({
    id: plan?.id,
    name:
      plan?.name === "PAYASYOUGO"
        ? "Pay As You Go"
        : plan?.name === "MONTHLY"
        ? "Monthly"
        : plan?.name === "FREEPLAN" && "Free Plan",
    price: plan?.price,
    details:
      plan?.name === "FREEPLAN" ? (
        <div className="form-check form-switch mb-0 mt-1 me-1">
          <input
            className="form-check-input cursor-pointer"
            type="checkbox"
            role="switch"
            checked={plan?.active}
            onChange={(e) => handleToggle(e, plan)}
          />
        </div>
      ) : (
        plan?.planDetails?.details?.map((detail, index) => <li key={index}>{detail}</li>)
      ),
    // actions: () => getActionButtons(plan),
  }));

  return (
    <div>
      <Table
        headings={headings}
        data={tableRows}
        addBtnText="Add Subscription Plan"
        addCallback={() => setIsAddOpen(true)}
        editBtnText="Edit Configuration"
        editCallback={() => setIsUpdateAllOpen(true)}
        card={true}
      />
      <AddModal
        isAddOpen={isAddOpen}
        closeAddModal={() => setIsAddOpen(false)}
        selectedPlan={selectedPlan}
        fetchPlans={fetchPlans}
      />
      <UpdateModal
        isUpdateOpen={isUpdateOpen}
        closeUpdateModal={() => setIsUpdateOpen(false)}
        selectedPlan={selectedPlan}
        fetchPlans={fetchPlans}
      />
      <RemoveModal
        isRemoveOpen={isRemoveOpen}
        closeRemoveModal={() => setIsRemoveOpen(false)}
        selectedPlan={selectedPlan}
        fetchPlans={fetchPlans}
      />
      <UpdateAllModal
        isUpdateAllOpen={isUpdateAllOpen}
        closeUpdateAllModal={() => setIsUpdateAllOpen(false)}
        selectedPlan={selectedPlan}
        fetchPlans={fetchPlans}
      />
      {loading && <Loader />}
    </div>
  );
};

export default PaymentConfig;
